import React from 'react';
export var GiveawayModalContext = /*#__PURE__*/ React.createContext({
    isOpen: false,
    onOpen: function() {},
    onClose: function() {},
    setStep: function(step) {},
    onComplete: function() {}
});
